(function(){
  "use strict";
  if (!document.getElementById("ols-nipple-chart")) return;

  /* ── DATA ── */
  var AGES = [
    { val: "preemie", label: "Premature", range: "Premature" },
    { val: "0-1m",    label: "0\u20131 month", range: "0\u20131 month" },
    { val: "1-3m",    label: "1\u20133 months", range: "1\u20133 months" },
    { val: "3-6m",    label: "3\u20136 months", range: "3\u20136 months" },
    { val: "6-9m",    label: "6\u20139 months", range: "6\u20139 months" },
    { val: "9-12m",   label: "9\u201312 months", range: "9\u201312 months" },
    { val: "12m+",    label: "12+ months", range: "12+ months" }
  ];

  var BRANDS = [
    { id: "dr-browns", name: "Dr. Brown\u2019s" },
    { id: "avent",     name: "Philips Avent" },
    { id: "tommee",    name: "Tommee Tippee" },
    { id: "nuk",       name: "NUK" },
    { id: "mam",       name: "MAM" },
    { id: "lansinoh",  name: "Lansinoh" },
    { id: "evenflo",   name: "Evenflo" },
    { id: "pigeon",    name: "Pigeon" }
  ];

  // Brand data: [preemie, 0-1m, 1-3m, 3-6m, 6-9m, 9-12m, 12m+]
  // Each entry: "Level Name" or null if not available
  var BRAND_DATA = {
    "dr-browns": [
      "Preemie Flow",
      "Level 1 (Slow)",
      "Level 1 (Slow)",
      "Level 2 (Medium)",
      "Level 3 (Fast)",
      "Level 4 (X-Fast)",
      "Y-Cut"
    ],
    "avent": [
      "Flow 0 (First)",
      "Flow 1 (Newborn)",
      "Flow 2 (Slow)",
      "Flow 3 (Medium)",
      "Flow 4 (Fast)",
      "Flow 5 (Extra Fast)",
      "Variable / Y-Cut"
    ],
    "tommee": [
      null,
      "Level 0 (Extra Slow)",
      "Level 1 (Slow)",
      "Level 2 (Medium)",
      "Level 3 (Fast)",
      "Level 3 (Fast)",
      "Y-Cut (Thick Feed)"
    ],
    "nuk": [
      null,
      "Size 1 Small (S)",
      "Size 1 Small (S)",
      "Size 1 Medium (M)",
      "Size 2 Medium (M)",
      "Size 2 Large (L)",
      "Size 2 Large (L)"
    ],
    "mam": [
      "Size 0 (Extra Slow)",
      "Size 1 (Slow)",
      "Size 1 (Slow)",
      "Size 2 (Medium)",
      "Size 3 (Fast)",
      "Size X (Cross-Cut)",
      "Size X (Cross-Cut)"
    ],
    "lansinoh": [
      null,
      "Size 2S (Slow)",
      "Size 2S (Slow)",
      "Size 3M (Medium)",
      "Size 4L (Fast)",
      "Size 4L (Fast)",
      "Size 4L (Fast)"
    ],
    "evenflo": [
      null,
      "Slow Flow",
      "Slow Flow",
      "Medium Flow",
      "Fast Flow",
      "Fast Flow",
      "X-Cut"
    ],
    "pigeon": [
      "SS (Extra Slow)",
      "S (Slow)",
      "S (Slow)",
      "M (Medium)",
      "L (Large)",
      "LL (X-Large)",
      "Y-Cut"
    ]
  };

  // Generic level data per age index
  var LEVELS = [
    { level: "Preemie / Level 0", flow: "Extra Slow", desc: "Designed for premature babies or very small newborns. The tiniest hole size with the slowest drip. Only use if your pediatrician recommends it \u2014 most full-term newborns do fine starting on Level 1." },
    { level: "Level 0 / Newborn", flow: "Extra Slow", desc: "For the first weeks of life. Baby\u2019s stomach is marble-sized \u2014 feeds are small and frequent. This slow flow helps prevent overfeeding and mimics the natural pace of breastfeeding." },
    { level: "Level 1", flow: "Slow", desc: "The standard newborn nipple. Ideal for breastfed babies supplementing with a bottle. Slow flow encourages proper suck-swallow-breathe coordination. Most babies stay on Level 1 for the first 3 months." },
    { level: "Level 2", flow: "Medium", desc: "Baby is getting stronger and more efficient at feeding. If Level 1 feeds are taking longer than 30 minutes or baby seems frustrated, it\u2019s time to move up. This is the most commonly used nipple level." },
    { level: "Level 3", flow: "Fast", desc: "For experienced eaters who drain a Level 2 bottle quickly and easily. Baby has strong jaw muscles and good swallow coordination. Common around the time solid foods are introduced." },
    { level: "Level 4 / Y-Cut", flow: "Extra Fast", desc: "For older babies and toddlers. Some brands offer a Level 4 with a larger hole; others switch to a Y-cut (adjustable slit). Y-cut nipples are also needed for thicker formulas like HiPP Anti-Reflux." },
    { level: "Y-Cut / Variable", flow: "Adjustable", desc: "Variable flow nipples adjust based on how hard baby sucks. Y-cut nipples handle thickened feeds (cereal, anti-reflux formula). Ideal for toddlers transitioning to cups who still take occasional bottles." }
  ];

  var FORMULA_TIPS = [
    "For premature babies, your pediatrician will recommend a specific formula. If using European formulas, HiPP PRE has the thinnest consistency.",
    "Newborns do best with lactose-only formulas like <a href='/products/hipp-dutch-stage-1'>HiPP Dutch Stage 1</a> or <a href='/products/hipp-bio-combiotik-pre'>HiPP German PRE</a>. Pair with a slow-flow nipple for paced feeding.",
    "At 1\u20133 months, most babies are on Stage 1 formula. <a href='/products/hipp-dutch-stage-1'>HiPP Dutch Stage 1</a> works perfectly with Level 1 nipples. If baby is gassy, the nipple \u2014 not the formula \u2014 may be the issue.",
    "At 3\u20136 months, baby may still be on Stage 1 formula. No need to switch formula and nipple at the same time \u2014 change one variable at a time so you can tell what helped.",
    "At 6\u20139 months, consider transitioning to Stage 2 formula (<a href='/products/hipp-dutch-stage-2'>HiPP Dutch Stage 2</a>). If using <a href='/products/hipp-anti-reflux-formula'>HiPP Anti-Reflux</a>, you\u2019ll need a Variable/Y-Cut nipple \u2014 regular nipples will clog.",
    "At 9\u201312 months, most babies are on Stage 2 or Stage 3 formula and eating solids. Formula provides ~50% of calories. A fast-flow nipple keeps feeds efficient.",
    "At 12+ months, consider <a href='/products/hipp-dutch-stage-4'>HiPP Dutch Stage 4</a> or <a href='/products/hipp-kindermilch-1'>HiPP Kindermilch 1+</a>. Many toddlers are transitioning to sippy cups \u2014 a Y-cut nipple for remaining bottle feeds works well."
  ];

  /* ── STATE ── */
  var selAge = 2; // default: 1-3 months
  var selBrand = -1; // -1 = all brands

  /* ── DOM ── */
  var $ages    = document.getElementById("onc-ages");
  var $brands  = document.getElementById("onc-brands");
  var $cta     = document.getElementById("onc-cta");
  var $res     = document.getElementById("onc-results");
  var $card    = document.getElementById("onc-result-card");
  var $tipBox  = document.getElementById("onc-tip-box");
  var $comp    = document.getElementById("onc-comp");
  var $signs   = document.getElementById("onc-signs");
  var $fTip    = document.getElementById("onc-formula-tip");

  if (!$ages || !$brands || !$cta) return;

  /* ── BUILD AGE BUTTONS ── */
  AGES.forEach(function(a, i) {
    var btn = document.createElement("button");
    btn.className = "onc-age-btn" + (i === selAge ? " active" : "");
    btn.textContent = a.label;
    btn.type = "button";
    btn.addEventListener("click", function() {
      selAge = i;
      $ages.querySelectorAll(".onc-age-btn").forEach(function(b,j){ b.className = "onc-age-btn" + (j===i?" active":""); });
      $res.classList.remove("visible");
    });
    $ages.appendChild(btn);
  });

  /* ── BUILD BRAND BUTTONS ── */
  var allBtn = document.createElement("button");
  allBtn.className = "onc-brand-btn active";
  allBtn.textContent = "All Brands";
  allBtn.type = "button";
  allBtn.addEventListener("click", function() {
    selBrand = -1;
    $brands.querySelectorAll(".onc-brand-btn").forEach(function(b,j){ b.className = "onc-brand-btn" + (j===0?" active":""); });
    $res.classList.remove("visible");
  });
  $brands.appendChild(allBtn);

  BRANDS.forEach(function(b, i) {
    var btn = document.createElement("button");
    btn.className = "onc-brand-btn";
    btn.textContent = b.name;
    btn.type = "button";
    btn.addEventListener("click", function() {
      selBrand = i;
      $brands.querySelectorAll(".onc-brand-btn").forEach(function(bb,j){ bb.className = "onc-brand-btn" + (j===i+1?" active":""); });
      $res.classList.remove("visible");
    });
    $brands.appendChild(btn);
  });

  /* ── RENDER ── */
  function render() {
    var age = AGES[selAge];
    var lv = LEVELS[selAge];

    // Result card
    var brandSpecific = "";
    if (selBrand >= 0) {
      var brand = BRANDS[selBrand];
      var nipple = BRAND_DATA[brand.id][selAge];
      if (nipple) {
        brandSpecific = '<div class="onc-result-name">' + brand.name + ': ' + nipple + '</div>';
      } else {
        brandSpecific = '<div class="onc-result-name" style="color:#cc6600">' + brand.name + ' does not offer a specific nipple for this age</div>';
      }
    }

    $card.innerHTML =
      '<div class="onc-result-level">' + lv.level + '</div>' +
      '<div class="onc-result-name" style="font-size:16px;color:#2d6a4f;margin-top:4px">' + lv.flow + ' Flow</div>' +
      '<div class="onc-result-age">Recommended for: ' + age.range + '</div>' +
      brandSpecific +
      '<div class="onc-result-desc">' + lv.desc + '</div>';

    // Tip box
    if (selAge > 0 && selAge < AGES.length - 1) {
      var prev = LEVELS[selAge - 1];
      var next = LEVELS[selAge + 1];
      $tipBox.innerHTML = '<div class="onc-tip"><strong>\uD83D\uDCA1 Transition note:</strong> Your baby is between ' + prev.level + ' and ' + next.level + '. If feeds take longer than 30 minutes, try the next level up. If baby coughs or gulps, drop back down. There\u2019s no rush \u2014 some babies stay on one level longer than the chart suggests.</div>';
    } else {
      $tipBox.innerHTML = '';
    }

    // Comparison table
    var thead = '<thead><tr><th>Brand</th>';
    var highlightCol = selAge;

    // Show 3 columns: current age + neighbors
    var cols = [];
    if (selAge > 0) cols.push(selAge - 1);
    cols.push(selAge);
    if (selAge < AGES.length - 1) cols.push(selAge + 1);

    cols.forEach(function(ci) {
      thead += '<th>' + AGES[ci].label + (ci === selAge ? ' \u2190' : '') + '</th>';
    });
    thead += '</tr></thead>';

    var tbody = '<tbody>';
    BRANDS.forEach(function(brand, bi) {
      var isSelBrand = (bi === selBrand);
      tbody += '<tr' + (isSelBrand ? ' style="background:#d4edda"' : '') + '>';
      tbody += '<td>' + brand.name + '</td>';
      cols.forEach(function(ci) {
        var val = BRAND_DATA[brand.id][ci];
        var cls = (ci === selAge) ? ' class="onc-highlight"' : '';
        if (!val) cls = ' class="onc-na"';
        tbody += '<td' + cls + '>' + (val || '\u2014') + '</td>';
      });
      tbody += '</tr>';
    });
    tbody += '</tbody>';
    $comp.innerHTML = thead + tbody;

    // Signs
    var signsUp = [
      "Feeds take longer than 30 minutes",
      "Baby falls asleep mid-feed repeatedly",
      "Baby tugs, bites, or pulls the nipple",
      "Baby seems frustrated and fussy during feeds",
      "Baby sucks hard but gets little milk"
    ];
    var signsDown = [
      "Baby coughs, chokes, or gags during feeds",
      "Milk leaks from corners of baby\u2019s mouth",
      "Baby gulps loudly and swallows air",
      "Baby finishes bottle in under 5 minutes",
      "Increased gas, spit-up, or colic symptoms"
    ];
    $signs.innerHTML =
      '<div class="onc-sign-col onc-sign-up">' +
        '<div class="onc-sign-title">\u2B06\uFE0F Move UP a size if\u2026</div>' +
        '<ul class="onc-sign-list">' + signsUp.map(function(s){return '<li>'+s+'</li>';}).join('') + '</ul>' +
      '</div>' +
      '<div class="onc-sign-col onc-sign-down">' +
        '<div class="onc-sign-title">\u2B07\uFE0F Move DOWN a size if\u2026</div>' +
        '<ul class="onc-sign-list">' + signsDown.map(function(s){return '<li>'+s+'</li>';}).join('') + '</ul>' +
      '</div>';

    // Formula tip
    $fTip.innerHTML = '<strong>\uD83C\uDF7C Formula pairing tip:</strong> ' + FORMULA_TIPS[selAge];

    $res.classList.add("visible");
    setTimeout(function(){ $res.scrollIntoView({ behavior:"smooth", block:"start" }); }, 100);
  }

  /* ── CTA ── */
  $cta.addEventListener("click", render);
})();